import {
    SIGNIN,
    SIGNIN_SUCCESS,
    SIGNIN_FAILURE,
    EMAIL_VERIFICATION,
    EMAIL_VERIFICATION_SUCCESS,
    EMAIL_VERIFICATION_FAILURE,
    OTP_VERIFICATION,
    OTP_VERIFICATION_SUCCESS,
    OTP_VERIFICATION_FAILURE,
    PASSWORD_RESET,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAILURE,
    LOGOUT,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    TOGGLE_SIDEBAR,
    DATA_UPDATE,
    VALID_COMPANY,
    GET_CURRENT_USER,
    GET_CURRENT_USER_SUCCESS,
    GET_CURRENT_USER_FAILURE,
    ADD_AVAILABILITY,
    ADD_AVAILABILITY_SUCCESS,
    ADD_AVAILABILITY_FAILURE,
    GET_AVAILABILITY,
    GET_AVAILABILITY_SUCCESS,
    GET_AVAILABILITY_FAILURE,
    DELETE_AVAILABILITY,
    DELETE_AVAILABILITY_SUCCESS,
    DELETE_AVAILABILITY_FAILURE,
    UPDATE_AVAILABILITY,
    UPDATE_AVAILABILITY_SUCCESS,
    UPDATE_AVAILABILITY_FAILURE,
    UPDATE_DATE_FORMAT,
    UPDATE_WEEK_CONFIG,
} from '../constants';

export class AppAction {
    static UpdateDateFormat(payload) {
        console.log('Dispatching UpdateDateFormat', payload);
        return {
            type: UPDATE_DATE_FORMAT,
            payload,
        };
    }
    static UpdateWeekConfig(payload) {
        return {
            type: UPDATE_WEEK_CONFIG,
            payload,
        };
    }
    static ToggleSidebar() {
        return {
            type: TOGGLE_SIDEBAR,
        };
    }
    static ValidCompany(payload) {
        return {
            type: VALID_COMPANY,
            payload,
        };
    }

    static SignIn(payload, cb) {
        console.log('action signin payload', payload);
        return {
            type: SIGNIN,
            payload,
            cb,
        };
    }
    static SignInSuccess(payload) {
        return {
            type: SIGNIN_SUCCESS,
            payload,
        };
    }
    static SignInFailure() {
        return {
            type: SIGNIN_FAILURE,
        };
    }
    static EmailVerification(payload, cb) {
        console.log(payload);
        return {
            type: EMAIL_VERIFICATION,
            payload,
            cb,
        };
    }
    static EmailVerificationSuccess() {
        return {
            type: EMAIL_VERIFICATION_SUCCESS,
        };
    }
    static EmailVerificationFailure() {
        return {
            type: EMAIL_VERIFICATION_FAILURE,
        };
    }
    static OTPVerification(payload, cb) {
        console.log(cb);
        return {
            type: OTP_VERIFICATION,
            payload,
            cb,
        };
    }
    static OTPVerificationSuccess() {
        return {
            type: OTP_VERIFICATION_SUCCESS,
        };
    }
    static OTPVerificationFailure() {
        return {
            type: OTP_VERIFICATION_FAILURE,
        };
    }
    static PasswordReset(payload, cb) {
        console.log(payload);
        return {
            type: PASSWORD_RESET,
            payload,
            cb,
        };
    }
    static PasswordResetSuccess() {
        return {
            type: PASSWORD_RESET_SUCCESS,
        };
    }
    static PasswordResetFaiure() {
        return {
            type: PASSWORD_RESET_FAILURE,
        };
    }
    static DataUpdate(payload) {
        console.log('action signin payload', payload);
        return {
            type: DATA_UPDATE,
            payload,
        };
    }

    static GetCurrentUser() {
        return {
            type: GET_CURRENT_USER,
        };
    }

    static GetCurrentUserSuccess(payload) {
        return {
            type: GET_CURRENT_USER_SUCCESS,
            payload,
        };
    }

    static GetCurrentUserFailure() {
        return {
            type: GET_CURRENT_USER_FAILURE,
        };
    }

    static Logout(payload, cb) {
        console.log(payload);
        return {
            type: LOGOUT,
            payload,
            cb,
        };
    }
    static LogoutSuccess() {
        return {
            type: LOGOUT_SUCCESS,
        };
    }
    static LogoutFailure() {
        return {
            type: LOGOUT_FAILURE,
        };
    }

    static AddAvailability(payload, cb) {

        return {
            type: ADD_AVAILABILITY,
            payload,
            cb
        };
    }

    static AddAvailabilitySuccess(payload) {
        return {
            type: ADD_AVAILABILITY_SUCCESS,
            payload,
        };
    }

    static AddAvailabilityFailure() {
        return {
            type: ADD_AVAILABILITY_FAILURE,
        };
    }

    static GetAvailability(payload, cb) {
        return {
            type: GET_AVAILABILITY,
            payload,
            cb
        };
    }

    static GetAvailabilitySuccess(payload) {
        return {
            type: GET_AVAILABILITY_SUCCESS,
            payload,
        };
    }

    static GetAvailabilityFailure() {
        return {
            type: GET_AVAILABILITY_FAILURE,
        };
    }

    static DeleteAvailability(payload, cb) {
        return { type: DELETE_AVAILABILITY, payload, cb };
    }
    static DeleteAvailabilitySuccess(payload) {
        return { type: DELETE_AVAILABILITY_SUCCESS, payload };
    }
    static DeleteAvailabilityFailure() {
        return { type: DELETE_AVAILABILITY_FAILURE };
    }

    static UpdateAvailability(payload, cb) {
        return { type: UPDATE_AVAILABILITY, payload, cb };
    }
    static UpdateAvailabilitySuccess(payload) {
        return { type: UPDATE_AVAILABILITY_SUCCESS, payload };
    }
    static UpdateAvailabilityFailure() {
        return { type: UPDATE_AVAILABILITY_FAILURE };
    }
}

export default AppAction;
